import Cookies from 'js-cookie'
import request from '@/utils/request'

export const TokenKey = 'DxwSoft-Token'
export const UserCodeKey = 'Login_UserCode'

export function login(data) {
  return request({ url: '/C00/Token', method: 'get', params: data }).then()
}

export function getInfo(data) {
  return request({ url: '/C00/UserInfo', method: 'get', params: data }).then()
}

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function getUsercode() {
  return Cookies.get(UserCodeKey)
}

export function setUsercode(usercode) {
  return Cookies.set(UserCodeKey, usercode)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function removeUserCode() {
  return Cookies.remove(UserCodeKey)
}

export function setItem(key, value) {
  return Cookies.set(key, value)
}

export function getItem(key) {
  return Cookies.get(key)
}

export function removeItem(key) {
  return Cookies.remove(key)
}

export default { login, getToken, setToken, getUsercode, setUsercode, removeToken, removeUserCode, setItem, getItem, removeItem, getInfo }
